import { Redirect, useLocalSearchParams } from 'expo-router';
import { APP_VARIANT } from '@/src/lib/buildInfo';
import { WorkTimeDesignPreview, type PreviewView } from '@/src/features/driver/workTime/preview/WorkTimeDesignPreview';
import { LIMITS_SCENARIOS, WORK_STATES, type LimitsScenario } from '@/src/features/driver/workTime/mocks';
import type { DriverWorkState } from '@/src/features/driver/workTime/types';

// ALL-136 design preview (example data, no API calls). Development and
// staging builds only: production builds redirect to the start page.
// Query: ?state=driving|available|resting&scenario=ok|warning|critical|reached|empty
//        &view=home|limits|notifications&capture=1
const VIEWS: PreviewView[] = ['home', 'limits', 'notifications'];

const pick = <T extends string>(value: string | string[] | undefined, allowed: T[], fallback: T): T => {
  const v = Array.isArray(value) ? value[0] : value;
  return allowed.includes(v as T) ? (v as T) : fallback;
};

export default function All136DesignPreviewRoute() {
  const params = useLocalSearchParams<{
    state?: string;
    scenario?: string;
    view?: string;
    capture?: string;
  }>();
  if (APP_VARIANT === 'production') return <Redirect href="/" />;
  return (
    <WorkTimeDesignPreview
      initialState={pick<DriverWorkState>(params.state, WORK_STATES, 'driving')}
      initialScenario={pick<LimitsScenario>(params.scenario, LIMITS_SCENARIOS, 'ok')}
      initialView={pick<PreviewView>(params.view, VIEWS, 'home')}
      captureMode={params.capture === '1'}
    />
  );
}
